import { Skeleton } from '@customink/pigment-react';

export function ProjectItemSkeleton() {
  return (
    <Skeleton
      data-testid="project-item-skeleton"
      height="170px"
      variant="rounded"
      width="100%"
    />
  );
}
